var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import styled from "styled-components";
import TableTree, { Cell, Header, Headers, Row, Rows, TableTreeDataHelper } from "@atlaskit/table-tree";
import { Spinner, useShowFlag, useLazyQuery } from "@atlassiansox/microscopekit";
import Lozenge from "@atlaskit/lozenge";
import { NetworkStatus } from "@apollo/client";
import SectionMessage from "@atlaskit/section-message";
import { isEmpty } from "lodash";
import { JiraIssueDetailsQuery } from "../../../graphql";
import { usePollingQuery } from "../../../hooks";
var tableTreeHelper = new TableTreeDataHelper({ key: "issue_id" });
export var ExerciseExperiments = function (_a) {
    var jiraUrl = _a.jiraUrl;
    var _b = useJiraIssues(jiraUrl), issues = _b.issues, isLoading = _b.isLoading, getChildIssues = _b.getChildIssues, fetchingChildrenIssue = _b.fetchingChildrenIssue;
    var content;
    if (isLoading) {
        content = (React.createElement("span", null,
            "Loading experiment tickets...",
            React.createElement(SpinnerContainer, null,
                React.createElement(Spinner, null))));
    }
    else if (isEmpty(issues)) {
        content = (React.createElement(SectionMessage, { title: "No experiment tickets!" }, "Executing a wargame plan will add experiment tickets here for each fault"));
    }
    else {
        content = (React.createElement(TableTree, null,
            React.createElement(Headers, null,
                React.createElement(Header, { width: "20%" }, "Ticket Id"),
                React.createElement(Header, { width: "25%" }, "Summary"),
                React.createElement(Header, { width: "15%" }, "Type"),
                React.createElement(Header, { width: "20%" }, "Status"),
                React.createElement(Header, { width: "20%" }, "Action")),
            React.createElement(Rows, { items: issues, render: function (_a) {
                    var issue_id = _a.issue_id, summary = _a.summary, issue_type = _a.issue_type, status = _a.status, issue_url = _a.issue_url, children = _a.children;
                    return (React.createElement(Row, { expandLabel: "Expand", collapseLabel: "Collapse", itemId: issue_id, onExpand: getChildIssues, items: children, hasChildren: issue_type === "Experiment" },
                        React.createElement(Cell, null,
                            React.createElement("a", { href: issue_url, target: "_blank", rel: "noopener noreferrer" }, issue_id),
                            React.createElement(SpinnerContainer, null, fetchingChildrenIssue &&
                                (fetchingChildrenIssue === null || fetchingChildrenIssue === void 0 ? void 0 : fetchingChildrenIssue.issue_id) === issue_id ? (React.createElement(Spinner, null)) : null)),
                        React.createElement(Cell, null, summary),
                        React.createElement(Cell, null, issue_type),
                        React.createElement(Cell, null,
                            React.createElement(Lozenge, { appearance: "inprogress" }, status)),
                        React.createElement(Cell, null, issue_type === "Experiment" ? (React.createElement("a", { href: issue_url, target: "_blank", rel: "noopener noreferrer" }, "Add action item")) : null)));
                } })));
    }
    return (React.createElement("div", null,
        React.createElement("h3", null, "Experiments"),
        React.createElement("br", null),
        content));
};
var useJiraIssues = function (jiraUrl) {
    var parentIssueId = jiraUrl.split("/").reverse()[0];
    var showFlag = useShowFlag();
    var _a = __read(useState([]), 2), issues = _a[0], setIssues = _a[1];
    var _b = usePollingQuery(JiraIssueDetailsQuery, {
        variables: { id: parentIssueId },
        notifyOnNetworkStatusChange: true,
        onCompleted: function (data) {
            var _a;
            var issuesFromBackend = (_a = data === null || data === void 0 ? void 0 : data.jiraIssueDetails[parentIssueId].childtasks) !== null && _a !== void 0 ? _a : [];
            var jiraBaseUrl = data.jiraIssueDetails.jira_web_url;
            issuesFromBackend = issuesFromBackend.map(function (newIssue) {
                var _a, _b;
                var existingIssue = issues.find(function (existingIssue) { return existingIssue.issue_id === newIssue.issue_id; });
                return __assign(__assign({}, newIssue), { children: (_a = existingIssue === null || existingIssue === void 0 ? void 0 : existingIssue.children) !== null && _a !== void 0 ? _a : [], isChildFetched: (_b = existingIssue === null || existingIssue === void 0 ? void 0 : existingIssue.isChildFetched) !== null && _b !== void 0 ? _b : false, issue_url: "" + jiraBaseUrl + newIssue.issue_id });
            });
            setIssues(tableTreeHelper.updateItems(issuesFromBackend, issues));
        },
        onError: function (e) {
            console.error(e);
            showFlag({
                type: "error",
                title: "Error",
                message: "Unable to fetch Jira details " + e.message
            });
        }
    }), isParentIssueLoading = _b.loading, networkStatus = _b.networkStatus;
    var _c = __read(useState(null), 2), fetchingChildrenIssue = _c[0], setFetchingChildrenIssue = _c[1];
    var _d = __read(useLazyQuery(JiraIssueDetailsQuery, {
        onCompleted: function (data) {
            var _a, _b;
            var issuesFromBackend = (_b = data === null || data === void 0 ? void 0 : data.jiraIssueDetails[(_a = fetchingChildrenIssue === null || fetchingChildrenIssue === void 0 ? void 0 : fetchingChildrenIssue.issue_id) !== null && _a !== void 0 ? _a : ""].childtasks) !== null && _b !== void 0 ? _b : [];
            var jiraBaseUrl = data.jiraIssueDetails.jira_web_url;
            issuesFromBackend = issuesFromBackend.map(function (x) { return (__assign(__assign({}, x), { issue_url: "" + jiraBaseUrl + x.issue_id, children: [] })); });
            if (fetchingChildrenIssue) {
                fetchingChildrenIssue.isChildFetched = true;
                setIssues(tableTreeHelper.updateItems(issuesFromBackend, issues, fetchingChildrenIssue));
                setFetchingChildrenIssue(null);
            }
        },
        onError: function (e) {
            setFetchingChildrenIssue(null);
            console.error(e);
            showFlag({
                type: "error",
                title: "Error",
                message: "Unable to fetch Jira details " + e.message
            });
        }
    }), 1), getJiraIssueDetails = _d[0];
    var getChildIssues = function (issue) {
        if (issue.isChildFetched) {
            return;
        }
        setFetchingChildrenIssue(issue);
        getJiraIssueDetails({ variables: { id: issue.issue_id } });
    };
    return {
        issues: issues,
        isLoading: isParentIssueLoading && networkStatus !== NetworkStatus.poll,
        getChildIssues: getChildIssues,
        fetchingChildrenIssue: fetchingChildrenIssue
    };
};
var SpinnerContainer = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  left: 1rem;\n"], ["\n  position: relative;\n  left: 1rem;\n"])));
var templateObject_1;
